import { emoticon } from '@/common/service/apiList';
const { buy, buyList, emoticonList, allEmoticonList, smileEmoticonList } = emoticon;
import ServiceExec from '@/common/utils/ServiceExec';
import store from '@/store';
import { isEmpty } from '@/common/utils/Util';

export default {
  async getBuyList({ commit }) {
    const { userNo } = store.getters['user/getUserData'];
    const { data, status } = await ServiceExec.get(buyList(userNo));
    if (status !== ServiceExec.status.OK) return false;
    commit('setBuyList', data.userEmoticonList ?? []);
    commit('setEmoticonList', data.shopEmoticonList ?? []);
  },

  async buyEmoticon({ commit, getters, state }, payload) {
    const { userNo } = await store.getters['user/getUserData'];
    const { funeralNo, emoticonNo } = payload;
    if (isEmpty(userNo)) return false;
    const { status } = await ServiceExec.patch(buy + userNo + '/' + funeralNo + '/' + emoticonNo);
    return status === ServiceExec.status.OK;
  },

  async getEmoticonList({ commit }, funeralNo) {
    const { userNo } = store.getters['user/getUserData'];
    try {
      const res = await ServiceExec.get(emoticonList(userNo, funeralNo));
      if (res?.status !== ServiceExec.status.OK) return false;
      commit('setBuyList', res?.data.userEmoticonList ?? []);
      commit('setEmoticonList', res?.data.shopEmoticonList ?? []);
      return true;
    } catch (error) {
      console.error('Error fetching emoticon list:', error);
      return false;
    }
  },

  async getSmileEmoticonList({ commit }, smileNo) {
    const { userNo } = store.getters['user/getUserData'];
    try {
      const response = await ServiceExec.get(smileEmoticonList(userNo, smileNo));
      if (response?.status !== ServiceExec.status.OK) return false;
      commit('setBuyList', response?.data.userEmoticonList ?? []);
      commit('setEmoticonList', response?.data.shopEmoticonList ?? []);
      return true;
    } catch (error) {
      console.error('Error fetching smile emoticon list:', error);
      return false;
    }
  },

  async getAllEmoticonList({ commit }) {
    const { data, status } = await ServiceExec.get(allEmoticonList);
    if (status !== ServiceExec.status.OK) return false;
    commit('setEmoticonList', data ?? []);
  }
};
